export default __webpack_public_path__ + "static/media/people.a073f50a.svg";